import RecheckAnswer from './RecheckAnswer';

export default RecheckAnswer;
